
import lazyload from "@/directives/lazyload";
import darts from "@/assets/images/landing/svg/mission.svg";
import dashboard from "@/assets/images/landing/svg/dash-board-composition.svg";
export default {
  data() {
    return {
      images: {
        darts,
        dashboard,
      },
    };
  },
  directives: {
    lazyload,
  },
};
